import { connect } from "react-redux"
// import { gridObjectDropped, selectFrameClip, setPropertyWindow, updateSwapHoverDrop, updateTransformStatus } from "../actions";
import GridComponent from "../components/Grid/GridComponent";

const mapStateToProps = () => ({
    // zoomFactor: state.localStore.get("zoomFactor"),
    // propertyWindow: state.localStore.get("propertyWindow"),
    // transformStatus: state.localStore.get("transformStatus"),
    // isLibraryItemDragging: state.localStore.get("isLibraryItemDragging"),
    // libraryImageDrag: state.localStore.get("libraryImageDrag"),
    // selectedItemId: state.localStore.getIn(["selectedItems", 0]),
    // selectedItem:
    //     state.localStore.get("selectedItems").size === 1
    //         ? state.project.getIn([
    //             "scenes", state.localStore.get("selectedScene"), "workspaceItems",
    //             state.localStore.getIn(["selectedItems", 0])
    //         ])
    //         : undefined,
    // swapHoverDrop: state.localStore.get("swapHoverDrop"),
    // propertyWindow: state.localStore.get("propertyWindow"),
    // selectedFrameClip: state.localStore.get("selectedFrameClip"),
    // selectedScene: state.localStore.get("selectedScene"),
    // sceneData: state.project.getIn(["scenes", state.localStore.get("selectedScene")]),
    // isSwapping: state.localStore.get("swapDetails") ? true : false,
    // selectedItems: state.localStore.get("selectedItems"),
});

const mapDispatchToProps = () => ({
    // selectFrameClip: (data) => dispatch(selectFrameClip(data)),
    // setPropertyWindow: (data) => dispatch(setPropertyWindow(data)),
    // updateSwapHoverDrop: (data) => dispatch(updateSwapHoverDrop(data)),
    // updateTransformStatus: (data) => dispatch(updateTransformStatus(data)),
    // gridObjectDropped: (data, socket) => dispatch(gridObjectDropped(data, socket)),
});

const Grid = connect(
    mapStateToProps,
    mapDispatchToProps
)(GridComponent);

export default Grid;


// WEBPACK FOOTER //
// ./src/containers/Grid.js